import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from "@/router";
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/reset.css';
import {createFromIconfontCN} from '@ant-design/icons-vue';

// 创建 IconFont
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_4441500_gday65zqcpq.js',
});

const pinia = createPinia()
const app = createApp(App);

app.use(pinia);
app.use(router);
app.use(Antd);

// 注册全局组件
app.component('IconFont', IconFont);

app.mount('#app');

